/**
 * Gratuity helpers.
 *
 * `0` is a real choice ("No gratuity", offered when the admin enables optional gratuity) and
 * must reach the API as 0 — an omitted/null gratuity_percentage means "use the default", which
 * is the lowest configured option, never 0. So "nothing chosen yet" is only '' / null / undefined.
 */
import {BOOKING_CONSTRAINTS} from '@/constants/booking'

/** Payload value for gratuity_percentage: the integer (0 included), or null when nothing was chosen. */
export function toTipPayload(value) {
    if (value === '' || value == null) return null
    const n = parseInt(value, 10)
    return Number.isNaN(n) ? null : n
}

/** True when a gratuity percentage has been chosen/reported (0 counts). */
export function hasTip(value) {
    return toTipPayload(value) != null
}

/**
 * True when a percentage the server reported (trip / calculate-cost) can be adopted into the tip
 * dropdown. A 0 only counts while "No gratuity" is actually offered: an older trip priced at 0 must
 * not make an edit send gratuity_percentage: 0 once the admin switch is off (that is a 422).
 */
export function isAdoptableTip(value) {
    const n = toTipPayload(value)
    if (n == null) return false
    return n !== 0 || BOOKING_CONSTRAINTS.DRIVER_TIP_OPTIONS.some((o) => Number(o) === 0)
}
